import React from 'react';
import { X, Pin, PinOff } from 'lucide-react';

function CommentsPanelHeader({ isPinned, onTogglePin, onClose }) {
  return (
    <div className="flex shrink-0 items-center justify-between gap-2 border-b border-gray-200 px-3 py-2">
      <h3 className="text-sm font-semibold text-gray-900">Comments</h3>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={onTogglePin}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
          aria-label={isPinned ? 'Unpin comments panel' : 'Pin comments panel'}
          title={isPinned ? 'Unpin' : 'Pin'}
        >
          {isPinned ? (
            <PinOff className="h-4 w-4 shrink-0" aria-hidden />
          ) : (
            <Pin className="h-4 w-4 shrink-0" aria-hidden />
          )}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1"
          aria-label="Close comments panel"
        >
          <X className="h-4 w-4 shrink-0" aria-hidden />
        </button>
      </div>
    </div>
  );
}

export default CommentsPanelHeader;
